import React, { useEffect, useState } from "react";
import { getStatistics } from "../api/statisticService";
import { sleep } from "../utils/sleep";
import CountUp from "react-countup";

const OurImpact = () => {
  const [statistics, setStatistics] = useState([]);
          const [loading, setLoading] = useState(true);
          const [error, setError] = useState(null);
        
            useEffect(() => {
            const fetchStatistics = async () => {
              try {
                // simulate network delay (3 sec)
                //await sleep(3000);
        
                const data = await getStatistics(); // asynchronous call
                setStatistics(data);
              } catch (err) {
                setError("Failed to load statistics.");
              } finally {
                setLoading(false);
              }
            };
        
            fetchStatistics();
            }, []);
          
          // Loading Overlay
          if (loading) {
            return (
              <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <span className="ms-3 fw-semibold">Loading statistics...</span>
              </div>
            );
          }
          
           // Error Message
          if (error) {
            return (
              <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
                <p className="text-danger fs-7">{error}</p>
                <button
                  className="btn btn-outline-primary mt-3"
                  onClick={() => window.location.reload()}
                >
                  Retry
                </button>
              </div>
            );
    }

  return (
    <section className="py-5 bg-light text-center">
      <div className="container">
        <div className="row g-4">
          {statistics.map((stat, index) => (
            <div key={index} className="col-6 col-md-3">
              <h1 className="fw-bold text-primary-color display-5">
                <CountUp
                  end={stat.number}
                  duration={2}
                  enableScrollSpy={true}
                  suffix={stat.suffix}
                />
              </h1>
              <p className="text-muted mb-0">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurImpact;
